import { zodResolver } from "@hookform/resolvers/zod";
import { Form } from "antd";
import dayjs from "dayjs";
import * as React from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import * as z from "zod";
import { schemaFormMarkAsPerformed } from "../../../features/forms/schemas/schemaFormMarkAsPerformed";
import { isDev } from "../../../utils/dev";
import FieldDate from "../fields/FieldDate";
import FieldTextArea from "../fields/FieldTextArea";
import FieldUpload from "../fields/FieldUpload/FieldUpload";

export const formNameMarkAsPerformed = "form-action-mark-performed";

export type FormMarkAsPerformedSchema = z.infer<
  typeof schemaFormMarkAsPerformed
>;

type Props = {
  onSubmit: SubmitHandler<FormMarkAsPerformedSchema>;
};

const FormMarkAsPerformed: React.FC<Props> = ({ onSubmit }) => {
  const {
    control,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<FormMarkAsPerformedSchema>({
    defaultValues: {
      dateDone: dayjs(new Date()),
    },
    resolver: zodResolver(schemaFormMarkAsPerformed),
  });

  if (isDev) {
    const formValues = watch(); // Get the form values state
    console.log("formValues", formValues);
    console.log("errors", errors);
  }

  return (
    <Form
      id={formNameMarkAsPerformed}
      onFinish={handleSubmit(onSubmit)}
      labelCol={{ span: 4 }}
    >
      <FieldDate<FormMarkAsPerformedSchema>
        errorMessage={errors?.dateDone?.message}
        control={control}
        name="dateDone"
        label="Date de rÃ©alisation"
      />
      <FieldTextArea<FormMarkAsPerformedSchema>
        errorMessage={errors?.comment?.message}
        control={control}
        name="comment"
        label="Description"
        placeholder="Description..."
        isVertical
      />
      <FieldUpload<FormMarkAsPerformedSchema>
        errorMessage={errors.attachedFiles?.message}
        name="attachedFiles"
        control={control}
        listType="picture"
        label=""
        placeholder=""
      />
    </Form>
  );
};

export default FormMarkAsPerformed;
